module.exports = __webpack_public_path__ + "img/20.bcf02539.png";